/** StakedCelo Account — pending-withdrawal enumeration (Celo mainnet
 *  42220). Account: `0x4aAD04D41FD7fd495503731C5a2579e19054C432`.
 *
 *  `getPendingWithdrawals(beneficiary)` returns parallel arrays of
 *  CELO `values` and LockedGold availability `timestamps` (unix
 *  seconds) — one entry per pending unlock created by
 *  `Account.withdraw`. */
export const StCeloAccountWithdrawalAbi = [
  {
    name: 'getPendingWithdrawals',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'beneficiary' }],
    outputs: [
      { type: 'uint256[]', name: 'values' },
      { type: 'uint256[]', name: 'timestamps' },
    ],
  },
] as const
